import { PatientStatusCard, TagColor } from '@equip.health/ui';

import OverviewLoading from '~/components/common/OverviewLoading';
import { PatientStatusHeaderPopover } from '~/components/maud/patients/profile/patient-header/PatientStatusHeaderPopover';
import { PATIENT_HEADER_TOP_LEVEL_ID } from '~/components/maud/patients/profile/patient-header/patientHeaderConstants';
import { TreatmentEpisodeStatus } from '~/lib/constants/patients.constants';

import { usePatientStatusHeaderData } from './usePatientStatusHeaderData';

interface PatientStatusHeaderProps {
  patientId: string;
  patientStatus: string;
  patientStatusCode: string;
  patientStatusColor: TagColor;
  primaryDiagnosis?: string;
}

export const PatientStatusHeader = ({
  patientId,
  patientStatus,
  patientStatusCode,
  patientStatusColor,
  primaryDiagnosis,
}: PatientStatusHeaderProps) => {
  const {
    activeInquiryDetail,
    displayData,
    insuranceAuthorizationEndDate,
    isLoading,
    lastContactDateISO,
    tentativeDischargeDate,
    treatmentEpisode,
  } = usePatientStatusHeaderData({
    patientId,
    patientStatus,
    patientStatusCode,
    patientStatusColor,
    primaryDiagnosis,
  });

  if (isLoading) {
    return (
      <OverviewLoading
        height={48}
        id={`${PATIENT_HEADER_TOP_LEVEL_ID}__loading`}
      />
    );
  }

  return (
    <PatientStatusHeaderPopover
      inquiryDetail={
        activeInquiryDetail?.status.name === patientStatus
          ? activeInquiryDetail
          : undefined
      }
      insuranceAuthorizationEndDate={insuranceAuthorizationEndDate}
      lastContactDateISO={lastContactDateISO}
      patientId={patientId}
      patientStatus={patientStatus}
      pausedDetails={
        patientStatus === TreatmentEpisodeStatus.PAUSED
          ? treatmentEpisode?.pausedDetails
          : undefined
      }
      primaryDiagnosis={primaryDiagnosis}
      tentativeDischargeDate={tentativeDischargeDate}
      treatmentEpisode={treatmentEpisode}
      triggerContent={
        <PatientStatusCard
          id={PATIENT_HEADER_TOP_LEVEL_ID}
          lineOne={displayData.lineOne}
          lineTwo={displayData.lineTwo}
          statusColor={displayData.statusColor}
          statusLabel={patientStatus}
        />
      }
    />
  );
};
